import { mainSearch, secondarySearch } from "../../components/indexDB/indexDBStora";
import { hashing } from "../encData";

export const ValidationEmployee = async (data,mode, t) => {
    const status = {
        message:"",
        status: false,
        data: {}
    }

    if(!data.fullName || (!data.user && data.job !== 'pilot')) {
        status.message = t("error:employee.validation.dataEmpty");
        return status;
    };
    
    const trimUser = (data.user || "").toLowerCase().trim();
    const full_name = (data.fullName || "").trim();

    if((trimUser.length < 5 || trimUser.length > 8) && data.job !== 'pilot') {
        status.message = t("error:employee.validation.weakChars");
        return status;
    }
    if(full_name.split(" ").filter(Boolean).length !== 4) {
        status.message = t("error:employee.validation.quarterName") 
        return status;
    }
    if((!data.password || data.password.length <= 7) && data.job !== 'pilot') {
        status.message = t("error:employee.validation.strongestPass");
        return status;
    }
    if(!data.job) {
        status.message = t("error:employee.validation.chooseJobTitle");
        return status;
    }
    if(!data.salary?.type) {
        status.message = t("error:employee.validation.typeSalary");
        return status;
    }
    if(data.salary.type !== "perOrder" && (!data.salary.value || isNaN(data.salary.value))) {
        status.message = t("error:employee.validation.SalaryValue");
        return status;
    }
    if(!data.details?.phone || !/^01[0-9]{9}$/.test(data.details.phone)) {
        status.message = t("error:employee.validation.vlidationPhoneNum");
        return status;
    }
    if(!data.details?.address) {
        status.message = t("error:employee.validation.address");
        return status;
    }
    if(!data.status && data.status !== false) {
        status.message = t("error:employee.validation.chooseStatus");
        return status;
    }
    if(!data.code || data.code.length > 4) {
        status.message = t("error:employee.validation.code");
        return status;
    }
    const repeatedCode = await mainSearch("employees", data.code);
    const repeatedUser = await secondarySearch("employees", "user" ,  data.user);
    if(repeatedUser.length !== 0 && data.job !== 'pilot' && mode === "record") {
        status.message =  t("error:employee.validation.repeatedUser");
        return status;
    }
    if(repeatedCode && mode === "record") {
        status.message = t("error:employee.validation.repeatedCode");
        return status;
    }
    const newData = { ...data };

    if (newData.password) {
        const encryptPass = await hashing(newData.password);
        newData.password = encryptPass;
    }

    // boolean status
    newData.status = newData.status === "true";

    status.data = newData;
    status.status = true;

    return status;
}